import angular from 'angular';
import { dateMinValidator, dateMaxValidator } from './date.validator';

export const DateValidator = angular
  .module('app.validators.date', [])
  .directive('uDateMin', dateMinValidator)
  .directive('uDateMax', dateMaxValidator);
